(function (angular) {
  'use strict';

  angular.module('Common').directive("fileUploader", function () {
    var controllerFu = ['$scope', '$element',
      function ($scope, $element) {
        var lastText = '';
        var ele = $element.find('.my_file');
        var textEle = $element.find('.fileinput-new');
        ele.on('change', function (e) {
          $scope.$apply(function () {
            console.log(ele[0].files);
            var val = ele[0].files[0] || {};
            var name = val.name || 'SELECT OR DROP FILE';
            textEle.text(name);
            $scope.objectWithFile[$scope.fileName] = val;
          });
        });
        ele.on('dragenter', function (e) {
          e.preventDefault();
          e.stopPropagation();
          lastText = textEle.text();
          textEle.text('DROP');
        });
        ele.on('dragleave', function (e) {
          e.preventDefault();
          e.stopPropagation();
          textEle.text(lastText);

        });
      }
    ];
    return {
      restrict: 'EA',
      scope: {
        objectWithFile: "=",
        fileName: "=",
        text: "=",
        acceptedTypes: "="
      },
      templateUrl: 'components/common/templates/directive.fileUploader.html',
      controller: controllerFu
    };
  });

})(window.angular);
